import fetchExpresso from 'utility/fetchExpresso';

import { toTicketId, type TicketOption } from '../ticketFilter';

type EventProduct = {
    product_id?: number | string;
    prod_name?: string;
    prod_type_id?: number;
    sort?: number;
};

export async function fetchEventTickets(eventId: number): Promise<TicketOption[]> {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/products`);

    if (!response.ok) {
        throw new Error('Failed to load tickets');
    }

    const products = (await response.json()) as EventProduct[];

    return products
        .map((product) => {
            const id = toTicketId(product.product_id);
            const name = product.prod_name;

            if (id === null || typeof name !== 'string' || name.length === 0) {
                return null;
            }

            return {
                id,
                name,
                prodTypeId: product.prod_type_id ?? 0,
                sort: product.sort ?? 0,
            };
        })
        .filter((product): product is TicketOption & { prodTypeId: number; sort: number } =>
            Boolean(product),
        )
        .sort((left, right) => {
            const typeDelta = left.prodTypeId - right.prodTypeId;
            if (typeDelta !== 0) {
                return typeDelta;
            }

            const sortDelta = left.sort - right.sort;
            if (sortDelta !== 0) {
                return sortDelta;
            }

            return left.name.localeCompare(right.name);
        })
        .map(({ id, name }) => ({ id, name }));
}
